<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTO.LBL_CONFIRVINCU' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormulario" name="nomFormulario">
      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOCONFVINC.LBL_VINCULACION' | translate }}</label>
            <fieldset *ngIf="!(productoConfirmacionVinculacion && productoConfirmacionVinculacion.idProductoConfirmacionVinculacion)">
              <p-dropdown disableTab  id="idTipoVinculacion" name="nomIdTipoVinculacion" [options]="lisVinculaciones"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                           formControlName="idTipoVinculacion"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoVinculacion.invalid">
                {{ 'PRODUCTOCONFVINC.LBL_VINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </fieldset>
            <fieldset *ngIf="productoConfirmacionVinculacion && productoConfirmacionVinculacion.idProductoConfirmacionVinculacion">
              <label class="falso-combo-texto">{{productoConfirmacionVinculacion.nombreTipoVinculacion}}</label>
            </fieldset>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>{{ 'PRODUCTOCONFVINC.LBL_CUESTIONARIO' | translate }}</label>
            <p-dropdown disableTab  id="idCuestionario" name="nomIdCuestionario" [options]="lisCuestionario"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idCuestionario"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCuestionario.invalid">
              {{ 'PRODUCTOCONFVINC.LBL_CUESTIONARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <fieldset *ngIf="!guardando">
            <button class="p-button-datatables" icon="fa fa-plus"
                    label="{{(productoConfirmacionVinculacion && productoConfirmacionVinculacion.idProductoConfirmacionVinculacion)?('BTN_ACTUALIZAR' | translate):('BTN_AGREGAR' | translate) }}"
                    type="submit"
                    pButton></button>
          </fieldset>
          <fieldset *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </fieldset>
        </div>
      </div>
    </form>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')"
               [(ngModel)]="busqueda" (change)="setBusqueda()">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carTabla" #dt
                 [value]="proConVinHabilitados()" selectionMode="single" dataKey="idProductoConfirmacionVinculacion"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreTipoVinculacion}}</td>
              <td>{{row.nombreCuestionario}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="!guardando"
                          (click)="editar(row)"></button>
                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                  <fieldset *ngIf="guardando">
                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                    <span>{{'LBL_GUARDANDO' | translate }}</span>
                  </fieldset>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="confirmacion-vinculacion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
